import { createSelector } from 'reselect';
import { ReduxStateType } from './types';

export const userSelector = (state: ReduxStateType) => state.userManagement;

export const getUserProfileInfoSelector = createSelector(
  userSelector,
  ({ user }) => user
);

export const getInvitationStatus = createSelector(
  userSelector,
  ({ invitationStatus }) => invitationStatus
);

export const getUsersListSelector = createSelector(
  userSelector,
  ({ usersList }) => usersList
);

export const getInvitationsListSelector = createSelector(
  userSelector,
  ({ invitationsList }) => invitationsList
);

export const getUsersListErrorSelector = createSelector(
  userSelector,
  ({ usersListError }) => usersListError
);

export const getCreateInvitationSuccessSelector = createSelector(
  userSelector,
  ({ createInvitationSuccess }) => createInvitationSuccess
);

export const getDeactivatedUsersSelector = createSelector(
  userSelector,
  ({ deactivatedUsersList }) => deactivatedUsersList
);

export const getRequestedUserDetailsSelector = createSelector(
  userSelector,
  ({ requestedUserProfileDetails }) => requestedUserProfileDetails
);
